import { createDarkTheme, type BrandVariants } from "@fluentui/react-components";

const brandVariants: BrandVariants = {
    10: "#020305",
    20: "#0a1524",
    30: "#0d2240",
    40: "#082e56",
    50: "#003a6d",
    60: "#004785",
    70: "#00549e",
    80: "#1a6fb5",  // primary
    90: "#3a87c7",
    100: "#549fd9",
    110: "#6db7ea",
    120: "#88cffb",
    130: "#a4deff",
    140: "#c2ecff",
    150: "#e0f6ff",
    160: "#f0fbff",
};

export const primerDarkTheme = {
    ...createDarkTheme(brandVariants),
    // Backgrounds
    colorNeutralBackground1: "#0d1117",
    colorNeutralBackground2: "#161b22",
    colorNeutralBackground3: "#21262d",
    colorNeutralBackground1Hover: "#1c2128",
    colorNeutralBackground1Pressed: "#21262d",
    // Foregrounds
    colorNeutralForeground1: "#e6edf3",
    colorNeutralForeground2: "#8b949e",
    colorNeutralForeground3: "#6e7681",
    // Strokes
    colorNeutralStroke1: "#30363d",
    colorNeutralStroke2: "#21262d",
    // Brand
    colorBrandForeground1: "#58a6ff",
    colorBrandBackground2: "rgba(56,139,253,0.15)",
    colorBrandStroke1: "#58a6ff",
};

/* Primer dark color constants */
export const primer = {
    canvas:     "#0d1117",
    surface:    "#161b22",
    overlay:    "#21262d",
    border:     "#30363d",
    borderMuted:"#21262d",
    fg:         "#e6edf3",
    fgMuted:    "#8b949e",
    fgSubtle:   "#6e7681",
    green:      "#218c21",
    greenBg:    "#0d2d1a",
    greenText:  "#2ea02e",
    red:        "#cc2635",
    redBg:      "#3d1418",
    redText:    "#e03e4a",
    orange:     "#f7630c",
    orangeBg:   "#3d1e00",
    orangeText: "#f7630c",
    yellow:     "#d0b232",
    yellowBg:   "#3d2e00",
    flakyYellow:    "#d0b232",
    flakyYellowBg:  "#3d2e00",
    purple:     "#a371f7",
    purpleBg:   "rgba(163,113,247,0.15)",
    blue:       "#58a6ff",
    header:     "#010409",
};
